const dureeDateTimeJour = 60 * 60 * 24 * 1000;
const convertStringToDate = (date) => {
    const dateParts = date.split('/');
    const day = Number(dateParts[0]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[2]);

    return new Date(year, month, day);
};

export default {
    methods: {
        formatMinutesToHours(totalMinutes) {
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            return `${hours}h${minutes < 10 ? '0' : ''}${minutes}`;
        },
        formatNumberToHours(numberHours) {
            const hours = Math.trunc(numberHours);
            const minutes = 60 * Number(numberHours - hours);

            return `${hours}h${minutes < 10 ? '0' : ''}${minutes}`;
        },
        formatDates(detail) {
            const sortedDates = detail.dates
                ? detail.dates
                      .slice()
                      .sort(
                          (a, b) =>
                              convertStringToDate(a.date).getTime() -
                              convertStringToDate(b.date).getTime()
                      )
                : [];
            if (sortedDates.length > 0) {
                if (sortedDates.length === 1) {
                    return `Le ${sortedDates[0].date}`;
                } else if (
                    sortedDates.every(
                        (date, index) =>
                            index === sortedDates.length - 1 ||
                            convertStringToDate(
                                sortedDates[index + 1].date
                            ).getTime() -
                                convertStringToDate(date.date).getTime() ===
                                dureeDateTimeJour
                    )
                ) {
                    return `Du ${detail.dateDebut} au ${detail.dateFin}`;
                } else {
                    return sortedDates
                        .map(
                            (date) =>
                                `${date.date}${date.matin && !date.aprem ? ' (matin)' : ''}${!date.matin && date.aprem ? ' (après-midi)' : ''}`
                        )
                        .join(', ');
                }
            } else if (detail.dateDebut && detail.dateFin) {
                if (detail.dateDebut === detail.dateFin) {
                    return `Le ${detail.dateDebut}`;
                } else {
                    return `Du ${detail.dateDebut} au ${detail.dateFin}`;
                }
            }
            return undefined;
        }
    }
};
